import { schema } from 'normalizr';

const tsAuctionDetailsSchema = new schema.Entity('tsAuctionDetails');

export default tsAuctionDetailsSchema;
